// extracted by mini-css-extract-plugin
export default {"GateBody":"clock_GateBody__0N2Na","InputContainer":"clock_InputContainer__pkW+v","Suffix":"clock_Suffix__WVFTc","PlayButton":"clock_PlayButton__1TCuV"};